// src/api/endpoints.js

const endpoints = {
  // Static
  // createUser: '/users',
  // Dashboard
  getDashboardDetails: "/Get_dashboard_details",
  getTopSellingItems: "/get_top_selling_items",

  getDoctorSale: "/Multi_filter_Dashbord",
  getProductSale: "/Multi_filter_Dashbord_product",
  getDistributorSale: "/get_all_distributor_records_Count",
  getDistributorWithCount: "/distributor_with_count",

  //Application report
  getAllCategory: "get_all_category",
  getDoctors: "/crm/search_contacts",
  RetrieveInventoryItemGroups: (id) => `Retrieve_inventory_item_groups?_=${id}`,
  getApplicationReportHeaderDetailsURL: "application_report_headers_details",
  getUserDetails: "/sales_tracking/sales_trcking_report",

  getSalesReports: "get_record_by_status",
  getSalesReportsWithQueriesURL: "merged_query_sales",
  getSalesReportHeaderDetailsURL: "sales_report_headers_details",

  //Purchase Order
  getPurchaseOrdersWithQueriesURL: "merged_query_sales",
  getPurchaseOrdertHeaderDetailsURL: "sales_report_headers_details",

  getDashboardHeaders: "Get_dashboard_headers_details",

  // Manage Users Tap
  getAllUsers: "Get_all_profiles",
  createUser: "AvanaCreateuser",

  // Product Sale Reports
  getProductSalesReportsURL: "sales_tracking/get_sale_status",

  // Product Sale Reports
  getProductLeadReportsURL: "sales_tracking/get_sale_status",

  // Dynamic
  updateUser: (id) => `/users/${id}`,
  deleteProduct: (id) => `/products/${id}`,
};

export default endpoints;
